import React, { useEffect, useState } from "react";
import profile from "../../assets/images/profile.svg";
import { More_horiz } from "../../utils/icons";
import { Avatar, Dropdown, Space } from "antd";
import { DownOutlined, SmileOutlined, UserOutlined } from "@ant-design/icons";
import { useNavigate, useNavigation } from "react-router-dom";
import { logOutAws } from "../../utils/aws";
import { useDispatch, useSelector } from "react-redux";
import { setIsAuthenticated } from "../../slices/authSlice";
import { LoadingOutlined } from "@ant-design/icons";
import DP from "../../assets/images/userDP.png";

import {
  getUserAllFormsDetails,
  getUserBasicInfo,
  setuserAttributesReducer,
} from "../../slices/userSlice";
import { getS3Media } from "../../services/awsServices";

function Profilebox() {
  const Navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  // const userBasicInfo = useSelector((state) => state.user.userBasicInfo);
  const userBasicInfo = useSelector((state) => state.user.userAllFormsDetails);
  const profile = userBasicInfo.find((data) => data.SK === "Profile#BasicInfo");
  // const profilePictureUrl = useSelector(
  //   (state) => state.modal.profilePictureUrl
  // );

  console.log(profile, "profileeeeeeeeeeeeeeeeeeeee");
  const [name, setName] = useState(null);
  const [dp, setDp] = useState(null);

  async function getImage(url) {
    console.log(userBasicInfo, " ===userBasicInfouserBasicInfo");
    setLoading(true);
    const res = await getS3Media(url);
    setDp(res?.data?.url);
    setLoading(false);
  }

  useEffect(() => {
    if (!profile) {
      dispatch(getUserAllFormsDetails()).unwrap();
    }
  }, []);

  useEffect(() => {
    console.log(profile, " ===proffffiiillllleeeeeeeee");
    if (profile) {
      getImage(profile?.Documents?.ProfilePicture);
    }
  }, [profile?.Documents?.ProfilePicture]);

  // useEffect(() => {
  //   // setLoading(true);
  //   dispatch(getUserBasicInfo())
  //   .unwrap()
  //   .then((res) => {
  //     console.log(res, "nsajndajnsjasnas");
  //     dispatch(setuserAttributesReducer({ ...res, sub: res.PK }));
  //     setName(res.Name);
  //   }).catch(err => {
  //     // setLoading(false);
  //   });
  // }, []);

  // useEffect(()=>{
  //   if(userBasicInfo?.ProfilePicture){
  //     getImage();
  //   }
  // else{
  //   setDp(DP)
  // }
  // }, [userBasicInfo?.ProfilePicture]);

  const handleLogout = () => {
    logOutAws();
    // localStorage.removeItem("accessToken");
    // localStorage.removeItem("username");
    dispatch(setIsAuthenticated(false));
    dispatch(setuserAttributesReducer(null));
    Navigate("/signin");
  };

  console.log(userBasicInfo, "=userBasicInfouserBasicInfouserBasicInfo");

  const items = [
    // {
    //   key: "1",
    //   label: (
    //     <p className="cursor-pointer" onClick={() => Navigate("/portfolio")}>
    //       Profile
    //     </p>
    //   ),
    // },
    // {
    //   key: "2",
    //   label: (
    //     <p className="cursor-pointer" onClick={() => Navigate("/portfolio")}>
    //       Portfolio
    //     </p>
    //   ),
    // },
    {
      key: "3",
      label: (
        <p className="cursor-pointer" onClick={handleLogout}>
          Logout
        </p>
      ),
    },
  ];
  const NameChar = profile?.Name.charAt(0);

  return (
    <div
      className="flex justify-between w-full py-2 px-3 bg-lightGrey items-center rounded-3xl gap-3"
      style={{
        boxShadow: "1px 10px 20px 0px #FF6B382B",
      }}
    >
      <div className="flex gap-x-3">
        <>
          <Avatar
            src={dp}
            style={{ backgroundColor: "#f56a00" }}
            size={"large"}
            icon={<UserOutlined />}
          >
            {NameChar}
          </Avatar>
        </>

        <div className="flex flex-col justify-center">
          <h1 className="font-semibold text-xl">
            {profile?.Name || "No name"}
          </h1>
          <p className="text-xs">{userBasicInfo?.Type}</p>
        </div>
      </div>
      {/* <More_horiz /> */}
      <Dropdown
        menu={{
          items,
        }}
      >
        <a onClick={(e) => e.preventDefault()}>
          <More_horiz />
        </a>
      </Dropdown>
    </div>
  );
}

export default Profilebox;
